// @flow
export const INIT_WAG_TAG = 'INIT_WAG_TAG';
export const GET_WAG_TAG = 'GET_WAG_TAG';
export const GET_WAG_TAG_SUCCESS = 'GET_WAG_TAG_SUCCESS';
export const GET_WAG_TAG_FAILURE = 'GET_WAG_TAG_FAILURE';
export const REGISTER_WAG_TAG = 'REGISTER_WAG_TAG';
export const REGISTER_WAG_TAG_SUCCESS = 'REGISTER_WAG_TAG_SUCCESS';
export const REGISTER_WAG_TAG_FAILURE = 'REGISTER_WAG_TAG_FAILURE';
export const UPDATE_WAG_TAG = 'UPDATE_WAG_TAG';
export const UPDATE_WAG_TAG_SUCCESS = 'UPDATE_WAG_TAG_SUCCESS';
export const UPDATE_WAG_TAG_FAILURE = 'UPDATE_WAG_TAG_FAILURE';
export const MANAGE_WAG_TAG_PLAN = 'MANAGE_WAG_TAG_PLAN';
export const MANAGE_WAG_TAG_PLAN_SUCCESS = 'MANAGE_WAG_TAG_PLAN_SUCCESS';
export const MANAGE_WAG_TAG_PLAN_FAILURE = 'MANAGE_WAG_TAG_PLAN_FAILURE';

export const REGISTER_OWNER = 'REGISTER_OWNER';
export const REGISTER_OWNER_SUCCESS = 'REGISTER_OWNER_SUCCESS';
export const REGISTER_OWNER_FAILURE = 'REGISTER_OWNER_FAILURE';

export const INIT_DOG = 'INIT_DOG';

export const ADD_DOG = 'ADD_DOG';
export const ADD_DOG_SUCCESS = 'ADD_DOG_SUCCESS';
export const ADD_DOG_FAILURE = 'ADD_DOG_FAILURE';

export const ADD_DOG_V4 = 'ADD_DOG_V4';
export const ADD_DOG_V4_SUCCESS = 'ADD_DOG_V4_SUCCESS';
export const ADD_DOG_V4_FAILURE = 'ADD_DOG_V4_FAILURE';

export const UPDATE_DOG = 'UPDATE_DOG';
export const UPDATE_DOG_SUCCESS = 'UPDATE_DOG_SUCCESS';
export const UPDATE_DOG_FAILURE = 'UPDATE_DOG_FAILURE';

export const ADD_ADDRESS = 'ADD_ADDRESS';
export const ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS';
export const ADD_ADDRESS_FAILURE = 'ADD_ADDRESS_FAILURE';

export const GET_VACCINES = 'GET_VACCINES';
export const GET_VACCINES_SUCCESS = 'GET_VACCINES_SUCCESS';
export const GET_VACCINES_FAILURE = 'GET_VACCINES_FAILURE';

export const ADD_VETERINARIAN = 'ADD_VETERINARIAN';
export const ADD_VETERINARIAN_SUCCESS = 'ADD_VETERINARIAN_SUCCESS';
export const ADD_VETERINARIAN_FAILURE = 'ADD_VETERINARIAN_FAILURE';

export const ADD_VET_TO_DOG = 'ADD_VET_TO_DOG';
export const ADD_VET_TO_DOG_SUCCESS = 'ADD_VET_TO_DOG_SUCCESS';
export const ADD_VET_TO_DOG_FAILURE = 'ADD_VET_TO_DOG_FAILURE';

export const ADD_VACCINATION = 'ADD_VACCINATION';
export const ADD_VACCINATION_SUCCESS = 'ADD_VACCINATION_SUCCESS';
export const ADD_VACCINATION_FAILURE = 'ADD_VACCINATION_FAILURE';

export const ADD_EMERGENCY_CONTACT = 'ADD_EMERGENCY_CONTACT';
export const ADD_EMERGENCY_CONTACT_SUCCESS = 'ADD_EMERGENCY_CONTACT_SUCCESS';
export const ADD_EMERGENCY_CONTACT_FAILURE = 'ADD_EMERGENCY_CONTACT_FAILURE';

export const GET_CARD_TOKEN = 'GET_CARD_TOKEN';
export const GET_CARD_TOKEN_SUCCESS = 'GET_CARD_TOKEN_SUCCESS';
export const GET_CARD_TOKEN_FAILURE = 'GET_CARD_TOKEN_FAILURE';

export const ADD_PAYMENT_METHOD = 'ADD_PAYMENT_METHOD';
export const ADD_PAYMENT_METHOD_SUCCESS = 'ADD_PAYMENT_METHOD_SUCCESS';
export const ADD_PAYMENT_METHOD_FAILURE = 'ADD_PAYMENT_METHOD_FAILURE';

export const INIT_OWNER = 'INIT_OWNER';

export const GET_OWNER_DETAILS = 'GET_OWNER_DETAILS';
export const GET_OWNER_DETAILS_SUCCESS = 'GET_OWNER_DETAILS_SUCCESS';
export const GET_OWNER_DETAILS_FAILURE = 'GET_OWNER_DETAILS_FAILURE';

export const GET_DOGS = 'GET_DOGS';
export const GET_DOGS_SUCCESS = 'GET_DOGS_SUCCESS';
export const GET_DOGS_FAILURE = 'GET_DOGS_FAILURE';

export const RESET_DOG = 'RESET_DOG';

export const UPDATE_APP_VERSION_OWNER = 'UPDATE_APP_VERSION_OWNER';
export const UPDATE_APP_VERSION_OWNER_SUCCESS = 'UPDATE_APP_VERSION_OWNER_SUCCESS';
export const UPDATE_APP_VERSION_OWNER_FAILURE = 'UPDATE_APP_VERSION_OWNER_FAILURE';

export const CREATE_SHELTER_ORDER = 'CREATE_SHELTER_ORDER';
export const CREATE_SHELTER_ORDER_SUCCESS = 'CREATE_SHELTER_ORDER_SUCCESS';
export const CREATE_SHELTER_ORDER_FAILURE = 'CREATE_SHELTER_ORDER_FAILURE';

export const GET_SHIPPING_PRICES = 'GET_SHIPPING_PRICES';
export const GET_SHIPPING_PRICES_FAILURE = 'GET_SHIPPING_PRICES_FAILURE';
export const GET_SHIPPING_PRICES_SUCCESS = 'GET_SHIPPING_PRICES_SUCCESS';

export const GET_WAG_TAG_GENERAL_INFO = 'GET_WAG_TAG_GENERAL_INFO';
export const GET_WAG_TAG_GENERAL_INFO_FAILURE = 'GET_WAG_TAG_GENERAL_INFO_FAILURE';
export const GET_WAG_TAG_GENERAL_INFO_SUCCESS = 'GET_WAG_TAG_GENERAL_INFO_SUCCESS';

export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAILURE = 'UPDATE_PASSWORD_FAILURE';
